import React from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';
import HomePage from './components/HomePage';
import DownloadPage from './components/DownloadPage';
import CasePage from './components/CasePage';
import './App.css';
import NavigationBar from "./components/NavigationBar";
import Footer from "./components/Footer";
import ProductPage from "./components/ProductPage";
import BrandCompanyPage from "./components/BrandCompanyPage";
import FaqPage from "./components/FaqPage";
import OfficialChannelsPage from "./components/OfficialChannelsPage";
import NotFoundPage from "./components/NotFoundPage";

function App() {
    return (
        <div className="App">
            <NavigationBar/>
            <div className="page-content">
              <Routes>
                  <Route path="/" element={<HomePage/>}/>
                  <Route path="/download" element={<DownloadPage/>}/>
                  <Route path="/case" element={<CasePage/>}/>
                  <Route path="/product" element={<ProductPage/>}/>
                  <Route path="/about/brand-and-company" element={<BrandCompanyPage/>}/>
                  <Route path="/product/qualification" element={<Navigate to="/product/" replace/>}/>
                  <Route path="/faq" element={<FaqPage/>}/>
                  <Route path="/official-channels" element={<OfficialChannelsPage/>}/>
                  <Route path="*" element={<NotFoundPage/>}/>
              </Routes>
              <Footer/>
            </div>
        </div>
    );
}

export default App;